import { mapState } from "vuex";
import formater from "./formatter";
import addoneHourToTime from "./AddHourToTime"

const GlobalMixins = {
  computed: mapState([
    // map this.count to store.state.count
    "$authentication",
    "$booking",
  ]),
  data() {
    return {
      states: [],
      cities: [],
    };
  },
  methods: {
    $_statusColors(status) {
      const opac = "25";
      switch (status) {
        case "pending":
          return { color: "#FFA600", backgroundColor: "#FCC21040" };
        case "received_at_origin_terminal":
          return { color: "#09B78A", backgroundColor: "#09B78A" + opac };
        case "dispatched_from_origin_terminal":
          return { color: "#10233E", backgroundColor: "#10233E" + opac };
        case "consolidated":
          return { color: "#FFA600", backgroundColor: "#FCC21040" };
        case "in_transit_to_destination_terminal":
          return { color: "#FFA600", backgroundColor: "#FCC21040" };
        case "arrived_at_destination_terminal":
          return { color: "#09B78A", backgroundColor: "#09B78A" + opac };
        case "unloading":
          return { color: "#10233E", backgroundColor: "#10233E" + opac };
        case "destination_sorting":
          return { color: "#FFA600", backgroundColor: "#FCC21040" };
        case "dispatched_for_delivery":
          return { color: "#09B78A", backgroundColor: "#09B78A" + opac };
        case "delivered":
          return { color: "#09B78A", backgroundColor: "#09B78A" + opac };
        case "canceled":
          return { color: "#D72638", backgroundColor: "#D72638" + opac };
        case "delayed":
          return { color: "#D72638", backgroundColor: "#D72638" + opac };
        case "handed_off":
          return { color: "#FFA600", backgroundColor: "#FCC21040" };
        case "dispatched":
          return { color: "#FFA600", backgroundColor: "#FCC21040" };
      }
    },
    outSideClick(element, callback) {
      document.addEventListener("click", function (event) {
        if (!element?.contains(event.target)) {
          callback();
        }
      });
    },
    _addoneHourToTime(val) {
      return addoneHourToTime(val)
    },
    amountFomatter(val) {
      return formater(val);
    },
    isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    $_removeTwakTo(style) {
      if (!document.getElementsByClassName("widget-visible")[0]) return;
      document.getElementsByClassName("widget-visible")[0].setAttribute('style', style)
    },
    $_addTwakTo() {
      // Avoid loading twice
      if (document.getElementById("tawk-script")) return;

      const s1 = document.createElement("script");
      s1.id = "tawk-script";
      s1.async = true;
      s1.src = "https://embed.tawk.to/68f21cfd3971cd194f4da742/1j7os2fsd";
      s1.charset = "UTF-8";
      s1.setAttribute("crossorigin", "*");
      document.body.appendChild(s1);
    },
    toTitleCase(str) {
      return str.replace(/\w\S*/g, function (txt) {
        return (txt || '').charAt(0).toUpperCase() + (txt || '').substr(1).toLowerCase();
      });
    },
    toSort(data, sortBy, ascending) {
      return data.sort((a, b) => {
        const x = a[sortBy].toLowerCase();
        const y = b[sortBy].toLowerCase();

        if (!ascending) return x > y ? -1 : x < y ? 1 : 0;
        return x < y ? -1 : x > y ? 1 : 0;
      });
    },
    isNumber(evt) {
      // console.log(evt.keyCode);
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode == 43) {
        // checks if the character is a plus sign
        return true;
      } else if (
        // checks if the character is not a number and prevents them from being entered
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    filterArray(array, query) {
      // Searches for "query" in "array" and returns items that contain the "query"
      if (!query || query.length == 0) {
        return array;
      } else {
        var filteredArray = [];
        for (let i = 0; i < array.length; i++) {
          // Returns an array containing all the values of all the properties in the current object
          let valuesInObject = Object.values(array[i]);
          var valuesMatchingQuery = valuesInObject.filter((currentValue) => {
            currentValue = String(currentValue).toLowerCase();
            query = query.toLowerCase();
            // console.log("current value", currentValue);
            // console.log("query", query);
            return currentValue.includes(String(query));
          });
          if (valuesMatchingQuery.length > 0) {
            filteredArray.push(array[i]);
          }
        }
        // console.log(filteredArray);
        return filteredArray;
      }
    },
    validateEmail(email) {
      let validate = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return validate.test(email);
    },
    formatAddress(address) {
      if (typeof address === "object" && address !== null) {
        return address.name;
      }
      return address;
    },
    capitalize(str) {
      return (str || '').charAt(0).toUpperCase() + (str || '').slice(1);
    },
    async getAllStatesAndCities() {
      try {
        let response = await this.$_getAllStatesAndCities();
        console.log(response, "getAllStates shippers");
        this.states = response.data.data;
        // this.fetchCitiesInState();
      } catch (error) {
        this.handleError(error);
      }
    },
    formatDate(value) {
      return value ? new Date(value).toLocaleDateString("en-gb") : "N/A";
    },
    getLocationDetails(id) {
      let locations = this.$store.getters.orgLocations;

      return locations.find((x) => x.id == id) != undefined
        ? locations.find((x) => x.id == id)
        : {};
    },
    getStatusDetails(status) {
      const statusArray = [
        { key: "accepted", config: { bgColor: '#09B78A', textColor: "", title: "Accepted", message: "Package Accepted" } },
        { key: "dispatched", config: { bgColor: '#09B78A', textColor: "", title: "Dispatched", message: "Package dispatched" } },
        { key: "delayed", config: { bgColor: '#FFA600', textColor: "", title: "Delayed", message: "Delivery is delayed" } },
        { key: "canceled", config: { bgColor: '#D72638', textColor: "", title: "Canceled", message: "Package delivery is canceled" } },
        { key: "pending", config: { bgColor: '#FFA600', textColor: "", title: "Pending", message: "Package delivery is pending" } },
        { key: "loading", config: { bgColor: '#FFA600', textColor: "", title: "Loading", message: "Package delivery is loading" } },
        { key: "draft", config: { bgColor: '#FFA600', textColor: "", title: "Draft", message: "Package is still a draft" } },
        { key: "active", config: { bgColor: '#FFA600', textColor: "", title: "Active", message: "Package is active" } },
        { key: "scheduled", config: { bgColor: '#FFA600', textColor: "", title: "Scheduled", message: "Package is Scheduled" } },
        { key: "completed", config: { bgColor: '#09B78A', textColor: "", title: "Completed", message: "Package is completed" } },
        { key: "delivered", config: { bgColor: '#C9FDF0', textColor: "#09B78A", title: "Delivered", message: "Package has been returned successfully" } },
        { key: "received", config: { bgColor: '#C9FDF0', textColor: "#09B78A", title: "Received", message: "Package has been returned successfully" } },
      ];

      return statusArray.find((item) => item.key == status);
    },
  },
  filters: {
    money: function (val) {
      return new Intl.NumberFormat().format(val);
    },
    capitalize(str) {
      return (str || '').charAt(0).toUpperCase() + (str || '').slice(1);
    },
    formatDate(value) {
      return value ? new Date(value).toLocaleDateString("en-gb") : "N/A";
    },
    formatTime(value) {
      return value ? new Date(value).toLocaleTimeString("en-gb") : "N/A";
    },
  },
};
export default GlobalMixins;
